import { LinearProgress, Typography } from "@mui/material";
import { Section } from "components/disw";
import { ErrorBox } from "components/error";
import { useSolutionKey } from "features/solution";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { createRoute } from "utils/url";
import DataSourceAccess from "./DataSourceAccess";
import DataSourceItem from "./DataSourceItem";
import DataSourceVersions from "./DataSourceVersions";
import { useDataSource } from "./hooks/useDataSources";
import { sortVersionsDescending } from "./versions";

export default function DataSourceDetail({
  dataSourceKey
}: {
  dataSourceKey: string;
}) {
  const solutionKey = useSolutionKey();
  const history = useHistory();
  const { data, loading, error, refetch } = useDataSource(
    solutionKey,
    dataSourceKey
  );
  const dataSource = data?.solutions.solution?.cloudDataSources?.dataSource;
  const versions = useMemo(
    () => sortVersionsDescending(dataSource?.allVersions ?? []),
    [dataSource]
  );
  const liveVersions = useMemo(
    () => versions.filter(item => item.isLive),
    [versions]
  );

  if (loading && !dataSource) return <LinearProgress />;
  if (error) return <ErrorBox apolloError={error} />;
  if (!dataSource)
    return <Typography>Data source {dataSourceKey} was not found.</Typography>;

  return (
    <DataSourceItem
      dataSource={{ ...dataSource, allVersions: liveVersions }}
      detailedView
    >
      <DataSourceAccess
        solutionKey={solutionKey}
        dataSourceKey={dataSourceKey}
        access={dataSource.access}
        onChanged={refetch}
      />
      <Section name="Versions">
        <DataSourceVersions
          versions={versions}
          onSelect={version =>
            history.push(
              createRoute(
                `/solutions/${solutionKey}/data-sources/${dataSourceKey}/${version}`
              )
            )
          }
        />
      </Section>
    </DataSourceItem>
  );
}
